import React from 'react';

const Divider = () => {
    return <div className='hr-line-dashed'/>
}

export default Divider